import type { InfoCard } from './types';
import { SHOWER_ICON, WASHING_MACHINE_ICON, OVEN_ICON } from './iconData';

export const INFO_CARDS: InfoCard[] = [
    {
        id: 'shower',
        title: 'å dusje i 10 minutter',
        icon: SHOWER_ICON,
        calculate: ({ priceOrePerKwh }) => ({
            value: (3.488 * priceOrePerKwh / 100).toFixed(1),
            unit: 'kr',
        }),
    },
    {
        id: 'washing-machine',
        title: 'å kjøre en vask på 60°C',
        icon: WASHING_MACHINE_ICON,
        calculate: ({ priceOrePerKwh }) => ({
            value: (1.072 * priceOrePerKwh / 100).toFixed(1),
            unit: 'kr',
        }),
    },
    {
        id: 'oven',
        title: 'å ha ovnen på i 24 timer (1000W)',
        icon: OVEN_ICON,
        calculate: ({ averageOrePerKwh }) => ({
            value: (24 * averageOrePerKwh / 100).toFixed(1),
            unit: 'kr',
        }),
    },
];

